<img appHideOnError *ngIf="icon" [src]="path" [title]="title ?? icon">